import { render, staticRenderFns } from "./CouponEdit.vue?vue&type=template&id=51c400d9&"
import script from "./CouponEdit.vue?vue&type=script&lang=js&"
export * from "./CouponEdit.vue?vue&type=script&lang=js&"
import style0 from "./CouponEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports